// TODO оставить одну константу стейдж

export const isStage = window.location.host.includes('-stage');

/* export const isStage = ['-stage', 'localhost', '127.0.0.1'].some(e =>
  window.location.host.includes(e),
); */

/* const isStage =
  window.location.host.includes('-stage') || window.location.host.includes('localhost'); */

/*  const isStage = ['-stage', 'localhost', '127.0.0.1'].some(e => window.location.host.includes(e)); */
